import { authedJson } from './client';
import { API_ROUTES } from '../../../shared/api';
import type { UpdateSettingsRequest, UserSettings } from '../../../shared/types';

type Auth = { getToken: () => string | null; doRefresh: () => Promise<boolean> };

export const settingsApi = {
  get: ({ getToken, doRefresh }: Auth) =>
    authedJson<UserSettings>(API_ROUTES.settings, { method: 'GET' }, getToken, doRefresh),

  update: (patch: UpdateSettingsRequest, { getToken, doRefresh }: Auth) =>
    authedJson<UserSettings>(
      API_ROUTES.settings,
      { method: 'PUT', body: JSON.stringify(patch) },
      getToken,
      doRefresh,
    ),
};
